import React from 'react'
import { theme, Button, Title, SubHeaderDesktop } from '@provi/provi-components'

import { Title as InformationTitle, ContainerDescont, ValueDiscount, ContainerOption } from './style'
import { currencyParser } from '../../../utils'
// import { SmallText } from '../../../components/SmallText'

function CourseConfirmation({ isMobile, setIsShowModal, creditPath, options, SelectedCourse, selectCourse, cursesSelect }) {
  return (
    <>
      <InformationTitle color={theme.colors.blue600}>Essa é uma tela de confirmação</InformationTitle>

      {isMobile ? (
        <Title text="Avance para confirmar o produto selecionado" />
      ) : (
        <SubHeaderDesktop
          title="Avance para confirmar o produto selecionado"
          handleModal={() => setIsShowModal(true)}
          isShowButtonHelpModal
        />
      )}

      {creditPath && creditPath.ReadISAProducts && creditPath.ReadISAProducts.total !== null && (
        <ContainerDescont>
          <ValueDiscount bold color={theme.colors.blue900}>
            Valor total:{' '}
            {currencyParser(
              creditPath &&
                creditPath.ReadISAProducts &&
                creditPath.ReadISAProducts.availableCourses &&
                creditPath.ReadISAProducts.availableCourses[0] &&
                creditPath.ReadISAProducts.availableCourses[0].price,
              'R$'
            )}
          </ValueDiscount>

          {/* <SmallText>*O valor final pode sofrer alteração por conta do IOF.</SmallText> */}
        </ContainerDescont>
      )}

      <ContainerOption>
        {creditPath &&
          creditPath.ReadISAProducts &&
          creditPath.ReadISAProducts.availableCourses &&
          creditPath.ReadISAProducts.availableCourses.map((item, key) => <SelectedCourse item={item} key={key} />)}
      </ContainerOption>

      <Button
        marginHorizontal={0}
        disabled={[...options, ...cursesSelect].length <= 0}
        text="Avançar"
        type="button"
        persistFloatingMode={false}
        onClick={async () =>
          await selectCourse(
            creditPath &&
              creditPath.ReadISAProducts &&
              creditPath.ReadISAProducts.availableCourses &&
              creditPath.ReadISAProducts.availableCourses[0],
            false
          )
        }
      />
    </>
  )
}

export default CourseConfirmation
